import { Users, Target, Shield, Heart } from 'lucide-react';

const Features = () => {
  const features = [
    {
      title: "Industry Professionals",
      description: "Learn from mentors actively working in top tech companies and startups.",
      icon: <Users className="w-6 h-6 text-[#0C7779]" />,
    },
    {
      title: "Project-Based Learning",
      description: "Build real-world projects that enhance your portfolio and skills.",
      icon: <Target className="w-6 h-6 text-[#0C7779]" />,
    },
    {
      title: "Transparent Approach",
      description: "No unrealistic promises—just honest guidance and measurable growth.",
      icon: <Shield className="w-6 h-6 text-[#0C7779]" />,
    },
    {
      title: "Supportive Community",
      description: "Collaborate with peers, share knowledge, and grow together.",
      icon: <Heart className="w-6 h-6 text-[#0C7779]" />,
    }
  ];

  return (
    <div className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-1 bg-[#F4FAF9] rounded-full text-[#0C7779] text-sm font-medium mb-3">
            WHY GROWON
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-4">
            A Different Kind of Learning Platform
          </h2>
          <p className="text-[#64748B] max-w-2xl mx-auto text-lg">
            Focused on real skills, real projects, and real results.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-6 border border-[#E2EFEA] hover:border-[#249E94]/40 hover:shadow-sm transition-all duration-300"
            >
              <div className="w-12 h-12 bg-[#3BC1A8]/10 rounded-lg flex items-center justify-center mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-[#0F172A] mb-3">{feature.title}</h3>
              <p className="text-[#64748B] leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;